import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { ShowcaseViewAllArtistsLink } from './ShowcaseViewAllArtistsLink'
import { showcaseArtistLabel } from '../../showcase/display'
import { fetchShowcaseLayout } from '../../showcase/fetchShowcase'
import type { ShowcaseLayout } from '../../showcase/types'
import { ShowcaseRenderer } from './ShowcaseRenderer'
import { ShowcaseShell } from './ShowcaseShell'

export function ShowcaseArtistPage() {
  const { artistSlug } = useParams<{ artistSlug: string }>()
  const [layout, setLayout] = useState<ShowcaseLayout | null>(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!artistSlug) {
      setError('Missing artist.')
      setLoading(false)
      return
    }
    setLoading(true)
    setError('')
    fetchShowcaseLayout(artistSlug)
      .then(setLayout)
      .catch((err) =>
        setError(err instanceof Error ? err.message : 'Failed to load showcase.'),
      )
      .finally(() => setLoading(false))
  }, [artistSlug])

  const label = showcaseArtistLabel(layout, artistSlug)

  return (
    <ShowcaseShell artistLabel={label} profileUsername={layout?.username}>
      {loading && (
        <p className="text-xs uppercase tracking-widest text-black/50 cursor-default">
          Loading…
        </p>
      )}
      {error && (
        <p className="text-xs uppercase tracking-widest text-red-700/90 cursor-default">
          {error}
        </p>
      )}
      {layout && <ShowcaseRenderer layout={layout} />}
      {artistSlug && <ShowcaseViewAllArtistsLink />}
    </ShowcaseShell>
  )
}
